import { useEffect } from 'react';

export default function SEO({ title, description, keywords, image, url }) {
    useEffect(() => {
        // Update document title
        if (title) {
            document.title = title;
        }

        // Update or create meta tags
        const updateMetaTag = (property, content) => {
            if (!content) return;

            let element = document.querySelector(`meta[property="${property}"]`) ||
                document.querySelector(`meta[name="${property}"]`);

            if (element) {
                element.setAttribute('content', content);
            } else {
                element = document.createElement('meta');
                if (property.startsWith('og:') || property.startsWith('twitter:')) {
                    element.setAttribute('property', property);
                } else {
                    element.setAttribute('name', property);
                }
                element.setAttribute('content', content);
                document.head.appendChild(element);
            }
        };

        // Standard meta tags
        updateMetaTag('description', description);
        if (keywords) updateMetaTag('keywords', keywords);

        // Open Graph tags
        updateMetaTag('og:title', title);
        updateMetaTag('og:description', description);
        updateMetaTag('og:type', 'website');
        if (url) updateMetaTag('og:url', url);
        if (image) updateMetaTag('og:image', image);

        // Twitter tags
        updateMetaTag('twitter:card', 'summary_large_image');
        updateMetaTag('twitter:title', title);
        updateMetaTag('twitter:description', description);
        if (image) updateMetaTag('twitter:image', image);
    }, [title, description, keywords, image, url]);

    return null;
}